import { Anchor } from '@/components/ui/Anchor'
import { Button } from '@/components/ui/button'

/** Stands in for a quote form that failed to load, with other ways to reach a broker. */
export function QuoteFormUnavailable({ phoneNumber }: { phoneNumber: string }) {
  return (
    <div role="alert" className="flex flex-col items-start gap-4">
      <h3 className="text-ink text-2xl font-bold tracking-[-0.01em]">The quote form didn’t load</h3>
      <p className="text-md text-ink-600 leading-relaxed">
        Call us at{' '}
        <Anchor href={`tel:${phoneNumber.replace(/[^\d+]/g, '')}`} className="text-ink font-bold underline">
          {phoneNumber}
        </Anchor>{' '}
        or email{' '}
        <Anchor href="mailto:hello@cai.ai" className="text-ink font-bold underline">
          hello@cai.ai
        </Anchor>
        , and a Cai broker will help you get quotes.
      </p>
      <Button variant="outline" onClick={() => window.location.reload()}>
        Try again
      </Button>
    </div>
  )
}
